import { useState, useEffect} from "react";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Styles from "./styles.module.scss";
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import ActivePositions from "./activePositions";
import { TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import { makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import {getProviderPositions } from "./services";
import { viewedpageMixpanel } from "../../utils/mixpanel";
import { getAPI } from "../../api";


function Positions() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 0);
  const BreadcrumsValues = ["Positions"];
  const [filterValues, setFilterValues] = useState<any>(null);
  const [selected, setSelected] = useState<number>(0);
  const [allPositions, setAllPositions] = useState<any>()
  const [appliedPositions, setAppliedPositions] = useState<any>()
  const [allPositionsTotal, setAllPositionsTotal] = useState<number>()
  const [appliedTotal, setAppliedTotal] = useState<number>()
  const customerId = localStorage.getItem('customerId') || ''
  const [filter, setFilter] = useState<any>(null)
  const [jobRoleList, setJobRoleList] = useState<any>()
  const [skillList, setSkillList] = useState<any>()

  
  useEffect(() => {
    getAllPositions('', 1, 25, 'allPosition');
    getAllPositions('', 1, 25, 'appliedPosition');
    viewedpageMixpanel()

    getAPI('https://api.ellow.io/common//api/v1/ml/job-roles').then((resp: any) => {
      if (resp && resp.status === 1) {
        setJobRoleList(resp.data)
      }
    })

    getAPI('https://api.ellow.io/common/api/v1/ml/skills').then((value: any) => {
      if (value && value.status === 1) {
        setSkillList(value.data)
      }
    })


    // getAllocation();
    // getCompanyList();
    // getPositionName();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllPositions = (
    searchValue: string,
    page: number,
    pageSize: number,
    tab?: string,
    filter?: any
  ) => {
    
    getProviderPositions(searchValue, page, pageSize, customerId, tab, filter).then((response) => {
      if (response && response.status === 1) {
        if (tab === 'appliedPosition') {
          setAppliedPositions(response.data)
          setAppliedTotal(response.totalCount[0].totalCount)
        }
        else {
          setAllPositions(response.data)
          setAllPositionsTotal(response.totalCount[0].totalCount)
        }
      }
  })
  };

  const findTab = (value: number) => {

    switch (value) {
      case 0:
        return ("allPosition");
      case 1:
        return ("appliedPosition");
      default:
        return ("allPosition");
    }
  };

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  const getPosition = (pageSize: any, pageNumber: number) => {   
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;
        getAllPositions('', page, pageSize, "allPosition", filterValues);
        getAllPositions('', page, pageSize, "appliedPosition", filterValues);
  }

  const searchChange = (e: string) => {
    
    let filters = filterValues !== null ? filter : {"filters":{ }}  
    getAllPositions(e, 1, 25, 'allPosition', filters)
    getAllPositions(e, 1, 25, 'appliedPosition', filters)
  };

  const applyFilter = (data: any) => {

    let filter =  {
      skills: data.skills,
      jobRole: data.jobRole,
      experience: data.experience ? {from: data.experience.min, to: data.experience.max} : {from: 0, t0: 20}
    }    
    setFilterValues(filter)
    let value = {
      filters : {
        skills: data.skills,
        skillsCombination: data.skillsCombination !== undefined ? data.skillsCombination.id : undefined,
        jobRole: data.jobRole,
        experience: data.experience
      }
    }
    setFilter(value)
    getAllPositions('', 1, 25, 'allPosition',value )
    getAllPositions('', 1, 25, 'appliedPosition',value)
  }

  const closeTag = (data: any) => { 
    
    let filter =  {
      skills: data.skills,
      jobRole: data.jobRole,
      experience: data.experience && {min: data.experience.min, max: data.experience.max}
    }    
    setFilterValues(filter)
    let value = {
      filters : {
        skills: data.skills,
        skillsCombination: data.skillsCombination !== undefined ? data.skillsCombination.id : undefined,
        jobRole: data.jobRole,
        experience: data.experience
      }
    }
    setFilter(value) 
    getAllPositions('', 1, 25, 'allPosition',value )
    getAllPositions('', 1, 25, 'appliedPosition',value)
  }

  const AllPositionsTab = <>All positions  <i>{allPositionsTotal}</i></>;
  const AppliedPositionsTab = <>Applied positions <i>{appliedTotal}</i></>;


  const pageChange = () => {
    getAllPositions(findTab(selected), 1, 25, "", filterValues);
  };

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          searchChange={searchChange}
          filterValues={filterValues}
          applyFilter={applyFilter}
          closeTag={closeTag}
          skillsList={skillList}
          jobRolesList={jobRoleList}
          type='positions'
        />
        <section className={Styles.positionWrapper}>
              
            <TabStrip selected={selected} onSelect={handleSelect}>
              <Tab title={AllPositionsTab} >
              <ActivePositions positions={allPositions} total={allPositionsTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
              <Tab title={AppliedPositionsTab}>
              <ActivePositions positions={appliedPositions} total={appliedTotal} getTableValues={pageChange} pageSize={getPosition}/>
              </Tab>
            
          </TabStrip>
        </section>
      </div>
    </section>
  );
}

export default Positions;
